import PropTypes from 'prop-types';
import React from 'react';

//

const UserContext = React.createContext();

//

function UserContextProvider({ children, labUser }) {
  //
  // Side-Effects

  React.useEffect(
    function _handleLabUserData() {
      if (
        labUser.loading ||
        !labUser.authenticated ||
        !labUser.students ||
        labUser.students.length
      ) {
        return;
      }

      // Create default profile if authenticated user doesn't have any students
      labUser.createProfile(
        {
          firstName: labUser.activeUser.firstName,
          lastName: labUser.activeUser.lastName,
        },
        false
      );
    },
    [labUser]
  );

  //
  // Render

  return <UserContext.Provider value={labUser}>{children}</UserContext.Provider>;
}

UserContextProvider.propTypes = {
  children: PropTypes.any.isRequired,
  labUser: PropTypes.object.isRequired,
};

// Exports
// -------

export { UserContext, UserContextProvider };

export default UserContext;
